<template>
  <v-card>
    <v-card-title>
      <h2 style="font-size: 18px; width: 100%;" class="mb-0">{{ $t('label.informacoes_bancarias') }}</h2>
      <h4 class="RegisterForm__H4">{{cliente.idExterno}} - {{ cliente.nomCliente }}</h4>
    </v-card-title>

    <div>
      <v-data-table
        id="tabela_info_banco"
        :headers="headers"
        :items="getClienteLista()"
        :no-data-text="$t('label.tabela_sem_conteudo')"
        hide-default-footer
      >
        <template v-slot:item.banco="{ item }">
          {{ item.nomBanco }}
        </template>
        <template v-slot:item.agencia="{ item }">
          {{ item.vlrAgencia }}
        </template>
        <template v-slot:item.conta="{ item }">
          {{ item.vlrConta }}
        </template>
      </v-data-table>
    </div>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        id="btn_fechar_info_banco"
        color="primary"
        text
        @click="fechar()"
      >
        {{ $tc('label.fechar', 1) }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    cliente: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      headers: [
        { text: this.$tc('label.banco', 1), value: 'banco', sortable: false },
        { text: this.$tc('label.agencia', 1), value: 'agencia', sortable: false },
        { text: this.$tc('label.conta', 1), value: 'conta', sortable: false },
      ],
    };
  },
  methods: {
    fechar() {
      this.$emit('fechar');
    },
    getClienteLista() {
      const lista = [];
      lista.push(this.cliente);
      return lista;
    },
  },
};
</script>
